import script from "./ProposalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProposalView.vue?vue&type=script&setup=true&lang=ts"

import "./ProposalView.vue?vue&type=style&index=0&id=7c3c0766&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3c0766"]])

export default __exports__